<template>
  <div class="booking-contact-step">
    <FormKit
      id="booking-contact-form"
      ref="contactForm"
      type="form"
      :actions="false"
      @submit="onSubmit"
      @submit-invalid="onSubmitInvalid"
    >
      <div class="booking-contact-step__grid booking-contact-step__grid--3">
        <FormKit
          label="First Name *"
          type="text"
          validation="alpha_spaces_hyphens:latin|required"
          name="FirstName"
          validation-label="first name"
          validation-visibility="blur"
          v-model="prefname"
          :disabled="readOnlyOTP"
          :readonly="readOnlyOTP"
          outer-class="booking-contact-field"
        />
        <FormKit
          label="Last Name *"
          type="text"
          validation="alpha_spaces_hyphens:latin|required"
          name="LastName"
          validation-label="last name"
          validation-visibility="blur"
          v-model="prelname"
          :disabled="readOnlyOTP"
          :readonly="readOnlyOTP"
          outer-class="booking-contact-field"
        />
        <FormKit
          label="Email Address *"
          type="email"
          validation="required|email"
          name="Email"
          validation-label="email"
          validation-visibility="blur"
          v-model="preemail"
          :disabled="readOnlyOTP"
          :readonly="readOnlyOTP"
          outer-class="booking-contact-field"
        />
      </div>

      <div class="booking-contact-step__grid booking-contact-step__grid--3">
        <FormKit
          label="Phone Number *"
          type="tel"
          validation="required|matches:/^[0-9]{10}$/"
          :validation-messages="{
            matches: 'Phone number must be of 10 digits',
          }"
          name="Phone"
          validation-label="phone number"
          validation-visibility="blur"
          v-model="prephone"
          :disabled="readOnlyOTP"
          :readonly="readOnlyOTP"
          outer-class="booking-contact-field"
        />
        <FormKit
          label="Address *"
          type="text"
          validation="alpha_spaces_numbers:latin|required"
          name="Address"
          validation-label="address"
          validation-visibility="blur"
          v-model="preaddress"
          :disabled="readOnlyBooking"
          :readonly="readOnlyBooking"
          outer-class="booking-contact-field"
        />
        <FormKit
          label="Booking Name *"
          type="text"
          validation="alpha_spaces_numbers:latin|required"
          name="BookingName"
          validation-label="booking name"
          validation-visibility="blur"
          v-model="prebookingName"
          :disabled="readOnlyBooking"
          :readonly="readOnlyBooking"
          outer-class="booking-contact-field"
        />
      </div>

      <FormKit
        label="Booking Note"
        placeholder="Remember to write in complete sentences."
        rows="4"
        type="textarea"
        validation="length:5,1000"
        name="Notes"
        validation-label="booking note"
        v-model="prebookingNote"
        :disabled="readOnlyBooking"
        :readonly="readOnlyBooking"
        outer-class="booking-contact-field booking-contact-field--full"
      />

      <div
        v-if="profitableOrganisation === 'true' || enableBusinessKey == 'true'"
        class="booking-contact-step__options"
      >
        <FormKit
          v-if="profitableOrganisation === 'true'"
          v-model="profitCheck"
          label="Please check this box if you are Not-For-Profit or Community Organisation."
          name="nonProfitBooking"
          type="checkbox"
          outer-class="booking-contact-field booking-contact-field--checkbox"
        />

        <div v-if="profitCheck" class="booking-contact-step__grid booking-contact-step__grid--2">
          <FormKit
            v-model="nonProfitableCompanyName"
            label="Business Name *"
            validation="required"
            placeholder="e.g Fairfield city council"
            type="text"
            name="nonProfitableCompanyName"
            validation-label="Business Name"
            outer-class="booking-contact-field"
          />
          <FormKit
            v-model="nonProfitableABN"
            label="Australian Business Registration Number (ABN)"
            placeholder="e.g 12345678900"
            validation="spaces_numbers|matches:/^[0-9]{11}$/"
            :validation-messages="{
              matches: 'Only Numbers are allowed with limit of 11 digits.',
            }"
            type="text"
            validation-label="Australian Business Registration Number(ABN)"
            name="NonProfitableABN"
            outer-class="booking-contact-field"
          />
        </div>

        <FormKit
          v-if="enableBusinessKey == 'true'"
          v-model="check"
          label="Check this box if you are booking on behalf of business"
          name="businessBooking"
          type="checkbox"
          :disabled="readOnlyBooking"
          outer-class="booking-contact-field booking-contact-field--checkbox"
        />

        <div v-if="check" class="booking-contact-step__grid booking-contact-step__grid--3">
          <FormKit
            label="Business/Organization/Company Name *"
            validation="required"
            placeholder="e.g Fairfield city council"
            type="text"
            name="companyName"
            validation-label="Business/Organization/Company Name"
            v-model="precompanyName"
            :disabled="readOnlyBooking"
            :readonly="readOnlyBooking"
            outer-class="booking-contact-field"
          />
          <FormKit
            label="Trading As"
            placeholder="e.g Fairfield Leisure Centre"
            type="text"
            name="TradeAs"
            v-model="pretradeAs"
            :disabled="readOnlyBooking"
            :readonly="readOnlyBooking"
            outer-class="booking-contact-field"
          />
          <FormKit
            label="Australian Business Registration Number (ABN) *"
            placeholder="e.g 12345678900"
            validation="required|spaces_numbers|matches:/^[0-9]{11}$/"
            :validation-messages="{
              matches: 'Only Numbers are allowed with limit of 11 digits.',
            }"
            type="text"
            validation-label="Australian Business Registration Number(ABN)"
            name="ABN"
            v-model="preABN"
            :disabled="readOnlyBooking"
            :readonly="readOnlyBooking"
            outer-class="booking-contact-field"
          />
        </div>
      </div>

      <div class="booking-contact-step__terms-panel">
        <h3 class="booking-contact-step__terms-heading">Terms and conditions</h3>
        <div v-if="termsMarkdownBlocks.length" class="booking-contact-step__terms-content">
          <div
            v-if="termsMarkdownBlocks.length === 1"
            class="booking-contact-step__terms-markdown"
            v-html="parseMarkdown(termsMarkdownBlocks[0])"
          />
          <ul v-else class="booking-contact-step__terms">
            <li
              v-for="(block, i) in termsMarkdownBlocks"
              :key="i"
              v-html="parseMarkdown(block)"
            />
          </ul>
        </div>

        <div class="booking-contact-step__terms-accept">
          <FormKit
            v-model="checkdes"
            label="I accept the general terms and conditions"
            name="terms"
            type="checkbox"
            validation="accepted"
            validation-visibility="blur"
            outer-class="booking-contact-field booking-contact-field--checkbox booking-contact-step__terms-accept-field"
          />
        </div>
      </div>
    </FormKit>
  </div>
</template>

<script>
import { getBookingGeneral } from "../../../store/vuexStore";
import { getVenueTermsAndConditionsWithSummary, checkExistingOnetimeUser } from "../../../../server/config";
import {
  getTermsItemText,
  normalizeTermsList,
  parseMarkdown,
} from "@/utils/parseMarkdown.js";
import {
  getOtpSession,
  mapOtpContactFromProfile,
  mapOtpProfileFromResponse,
  setOtpBookingHoursRemaining,
  syncLegacyOtpSessionFromStorage,
} from "@/utils/otpSession.js";

export default {
  emits: ["validity-change"],
  data() {
    return {
      prefname: "",
      prelname: "",
      preemail: "",
      prephone: "",
      preaddress: "",
      prebookingName: "",
      prebookingNote: "",
      precompanyName: "",
      pretradeAs: "",
      preABN: "",
      nonProfitableCompanyName: "",
      nonProfitableABN: "",
      profitCheck: false,
      check: false,
      checkdes: false,
      readOnlyOTP: false,
      readOnlyBooking: false,
      profitableOrganisation: sessionStorage.getItem("enablekey") || false,
      enableBusinessKey: sessionStorage.getItem("enablebusinesskey") || false,
      termsAndConditionsValues: [],
      pendingResolve: null,
    };
  },
  computed: {
    isFormComplete() {
      const trim = (v) => (v == null ? "" : String(v).trim());

      if (!trim(this.prefname)) return false;
      if (!trim(this.prelname)) return false;
      if (!trim(this.preemail)) return false;
      if (!/^\S+@\S+\.\S+$/.test(trim(this.preemail))) return false;
      if (!/^[0-9]{10}$/.test(trim(this.prephone))) return false;
      if (!trim(this.preaddress)) return false;
      if (!trim(this.prebookingName)) return false;
      if (!this.checkdes) return false;

      if (this.profitCheck) {
        if (!trim(this.nonProfitableCompanyName)) return false;
        if (
          trim(this.nonProfitableABN) &&
          !/^[0-9]{11}$/.test(trim(this.nonProfitableABN))
        ) {
          return false;
        }
      }

      if (this.check) {
        if (!trim(this.precompanyName)) return false;
        if (!trim(this.preABN) || trim(this.preABN).length < 11) return false;
      }

      return true;
    },
    termsMarkdownBlocks() {
      return this.termsAndConditionsValues
        .map((item) => getTermsItemText(item))
        .filter(Boolean);
    },
  },
  watch: {
    isFormComplete: {
      handler(value) {
        this.$emit("validity-change", value);
      },
      immediate: true,
    },
  },
  async created() {
    const selectedVenueId = sessionStorage.getItem("selectedvenuetypeId") || "";
    let terms = [];

    if (selectedVenueId) {
      try {
        const response = await getVenueTermsAndConditionsWithSummary(selectedVenueId);
        terms =
          response?.termsAndConditions ||
          response?.termsandconditions ||
          response?.terms ||
          [];
        if (!terms.length && typeof response?.content === "string") {
          terms = [response.content];
        }
      } catch {
        // terms optional
      }
    }

    if (!terms.length) {
      terms = getBookingGeneral()?.termsAndConditions || [];
    }

    this.termsAndConditionsValues = normalizeTermsList(terms);

    if (sessionStorage.getItem("readOnlyOTP") === "true") {
      this.readOnlyOTP = true;
    }
  },
  mounted() {
    syncLegacyOtpSessionFromStorage();
    const session = getOtpSession();
    if (session?.profile?.email) {
      this.applyOtpProfile(session.profile, session.bookingHoursRemaining);
      return;
    }

    const onetimeToken = sessionStorage.getItem("onetimeToken");
    if (onetimeToken) {
      this.checkPrefill(
        sessionStorage.getItem("email"),
        sessionStorage.getItem("selectedvenuetype")
      );
    }
  },
  methods: {
    parseMarkdown,
    applyOtpProfile(profile, bookingHours) {
      this.applyContactValues(mapOtpContactFromProfile(profile));
      this.readOnlyOTP = true;
      sessionStorage.setItem("readOnlyOTP", "true");

      if (profile.bookingname?.trim()) {
        this.readOnlyBooking = true;
      }

      if (bookingHours != null) {
        setOtpBookingHoursRemaining(bookingHours);
      }
    },
    applyContactValues(values = {}) {
      this.prefname = values.FirstName || "";
      this.prelname = values.LastName || "";
      this.preaddress = values.Address || "";
      this.prephone = values.Phone || "";
      this.preemail = values.Email || "";
      this.prebookingName = values.BookingName || "";
      this.prebookingNote = values.Notes || "";
      this.precompanyName = values.companyName || "";
      this.pretradeAs = values.TradeAs || "";
      this.preABN = values.ABN || "";
      this.nonProfitableCompanyName = values.nonProfitableCompanyName || "";
      this.nonProfitableABN = values.NonProfitableABN || "";
      this.profitCheck = Boolean(values.nonProfitBooking);
      this.check = Boolean(values.businessBooking);
      this.checkdes = Boolean(values.terms);
    },
    resetForm() {
      this.prefname = "";
      this.prelname = "";
      this.preemail = "";
      this.prephone = "";
      this.preaddress = "";
      this.prebookingName = "";
      this.prebookingNote = "";
      this.precompanyName = "";
      this.pretradeAs = "";
      this.preABN = "";
      this.nonProfitableCompanyName = "";
      this.nonProfitableABN = "";
      this.profitCheck = false;
      this.check = false;
      this.checkdes = false;
      sessionStorage.removeItem("bookingWizardContact");
    },
    validateAndGetValues() {
      return new Promise((resolve) => {
        this.pendingResolve = resolve;
        const formRef = this.$refs.contactForm;
        if (formRef?.node) {
          formRef.node.submit();
        } else {
          resolve(null);
        }
      });
    },
    onSubmit(data) {
      if (this.pendingResolve) {
        this.pendingResolve(data);
        this.pendingResolve = null;
      }
    },
    onSubmitInvalid() {
      if (this.pendingResolve) {
        this.pendingResolve(null);
        this.pendingResolve = null;
      }
    },
    async checkPrefill(email, venueType) {
      if (!email || !venueType) return;

      try {
        const data = await checkExistingOnetimeUser(email, venueType);
        if (!data || data.status !== 1 || !data.response) return;

        const profile = mapOtpProfileFromResponse(data.response);
        this.applyOtpProfile(profile, data.response.bookinghours);

        if (data.response.id) {
          sessionStorage.setItem("otpUserId", data.response.id);
        }
      } catch (error) {
        console.error("OTP contact prefill failed:", error);
      }
    },
  },
};
</script>

<style src="./bookingcontact.css"></style>
